<template>
  <div
    v-if="show"
    class="add-on-tile card card-shadow-hover bg-secondary text-white py-1"
    @click="onTileClick()"
    role="button"
  >
  <v-icon style="font-size: 3.5rem; line-height: 1.5;" large color="white">{{getAddOnIcon(addon)}}</v-icon>
  {{addon.Description}}

  </div>
</template>

<script>
import { getInternalRoute } from '@/utils/routing'
import { ActivationStatus } from '@/enums/add-on/activation-status'

const statusText = {
  [ActivationStatus.NeverSubscribed]: 'Ikke aktivert',
  [ActivationStatus.InActivationProssess]: 'Fortsett med aktivering',
  [ActivationStatus.Subscribed]: 'Aktivert',
  [ActivationStatus.UnSubscribedButNotStopped]: 'Aktivert',
  [ActivationStatus.SubscriptionStopped]: 'Re-aktiver'
}
export default {
  props: {
    addon: {
      required: true,
      type: Object
    },
    show: {
      required: true,
      type: Boolean
    }
  },
  computed: {
    activationStatus () {
      return this.$store.getters['addons/getActivationStatusForAddon'](this.addon.Id)
    },
    activationStatusText () {
      return statusText[this.activationStatus] || ''
    }
  },

  methods: {
    onTileClick () {
      let url = this.getPageUrl(this.addon, this.activationStatus)
      this.navigate(url)
    },

    getPageUrl (addOn, activationStatus) {
      let url = ''
      switch (activationStatus) {
        // 1. To promotion page
        case ActivationStatus.NeverSubscribed:
        case ActivationStatus.SubscriptionStopped:
          url = addOn.PromotionUrl
          break
        // 2. To activation page
        case ActivationStatus.InActivationProssess:
          url = addOn.ActivationUrl
          break
        // 3. To application page
        case ActivationStatus.Subscribed:
        case ActivationStatus.UnSubscribedButNotStopped:
          url = addOn.ApplicationUrl
          break
        default:
          url = ''
          break
      }
      return url
    },

    navigate (url) {
      let route = getInternalRoute(url)
      // internal app navigation
      if (route) {
        this.$router.push(route)
      } else if (url) { // external navigation
        document.location.href = url
      }
    },
    getAddOnIcon (addon) {
      switch (addon.EnumTypeId) {
        case 1:
          return 'mdi-cart'
        case 2:
          return ''
        case 3:
          return ''
      }
    }
  }
}
</script>

<style  lang="scss" scoped>
.add-on-tile {
  height: 110px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
